import { type ImageProps as ChakraImageProps } from '@chakra-ui/react';
import { Image as ChakraImage } from '@chakra-ui/react';

type Props = ChakraImageProps;
export type ImageProps = Props;

export const Image: React.FC<Props> = (props) => {
  const { src, ...rest } = props;

  return <ChakraImage {...rest} src={src || undefined} />;
};
